(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@smartdesign/button"), require("lit"), require("lit/decorators.js"));
	else if(typeof define === 'function' && define.amd)
		define(["@smartdesign/button", "lit", "lit/decorators.js"], factory);
	else if(typeof exports === 'object')
		exports["@smartdesign/app-banner"] = factory(require("@smartdesign/button"), require("lit"), require("lit/decorators.js"));
	else
		root["@smartdesign/app-banner"] = factory(root["@smartdesign/button"], root["lit"], root["lit/decorators.js"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__150__, __WEBPACK_EXTERNAL_MODULE__870__, __WEBPACK_EXTERNAL_MODULE__931__) => {
return 